import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableShipFromAddressValidation = () => {
  return useFeatureFlag(FeatureFlagDeclarations.enableShipFromAddressValidation);
};
